
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-upload",
      function () {
        return require("private-next-pages/data-upload.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-upload"])
      });
    }
  